import { Col, Row } from "reactstrap";
import { TemplateFeaturesData } from "../../Data/Landing/Landing";
import { dynamicImage, Image } from "../../Utils";

const TemplateFeatures = () => {
  return (
    <section className="section-py-space template-features">
      <div className="custom-container">
        <Row className="align-items-center justify-content-center">
          <Col xl="4" lg="5" xs="12">
            <div className="template-features-content">
              {TemplateFeaturesData.map((item, index) => (
                <div className="d-flex" key={index}>
                  <div className="flex-shrink-0">
                    <Image className="img-fluid" src={dynamicImage(`index/features/${item.image}.png`)} alt="Education" />
                  </div>
                  <div className="flex-grow-1">
                    <h3>{item.title}</h3>
                    <p className="mb-0">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
          <Col xl="8" lg="7" xs="12">
            <div className="features-img text-end">
              <Image className="img-fluid" src={dynamicImage("index/features/4.png")} alt="faq" />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default TemplateFeatures;
